<script setup>
import { ref } from 'vue'
import { UI_TEMPLATES, activeUiTemplateId, setUiTemplate } from '../ui-template'

// Shared by both interface templates (classic Settings → Appearance and the
// new template's Appearance page), so either one can switch to the other.
const switchingTo = ref(null)

const choose = (id) => {
  if (id === activeUiTemplateId || switchingTo.value) return
  switchingTo.value = id
  setUiTemplate(id)
}
</script>

<template>
  <div>
    <h3 class="text-sm font-medium text-gray-700">Interface template</h3>
    <p class="mt-1 text-sm text-gray-500">
      Saved in this browser. Switching reloads the page and keeps you on the same page.
    </p>

    <div class="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
      <button
        v-for="t in UI_TEMPLATES"
        :key="t.id"
        type="button"
        class="flex flex-col text-left p-4 border rounded-lg transition-colors"
        :class="t.id === activeUiTemplateId
          ? 'border-gray-900 ring-1 ring-gray-900 bg-white'
          : 'border-gray-200 bg-white hover:border-gray-400'"
        :disabled="switchingTo !== null"
        @click="choose(t.id)"
      >
        <!-- Layout sketch -->
        <div class="h-16 rounded border border-gray-200 bg-gray-50 overflow-hidden flex" :class="t.preview === 'topbar' ? 'flex-col' : 'flex-row'">
          <template v-if="t.preview === 'sidebar'">
            <div class="w-3 bg-gray-400"></div>
            <div class="w-8 bg-gray-200 border-r border-gray-300"></div>
          </template>
          <div v-else class="h-3 bg-gray-400"></div>
          <div class="flex-1 p-2 space-y-1">
            <div class="h-1.5 w-2/3 bg-gray-200 rounded"></div>
            <div class="h-1.5 w-1/2 bg-gray-200 rounded"></div>
          </div>
        </div>

        <div class="mt-3 flex items-center justify-between gap-2">
          <span class="font-medium text-gray-900">{{ t.name }}</span>
          <span v-if="t.id === activeUiTemplateId" class="text-xs font-medium text-gray-900">
            <i class="fas fa-check mr-1"></i>Active
          </span>
          <span v-else-if="switchingTo === t.id" class="text-xs text-gray-500">Switching…</span>
        </div>
        <p class="mt-1 text-sm text-gray-500">{{ t.description }}</p>
      </button>
    </div>

    <p class="mt-3 text-xs text-gray-400">
      If a template fails to load, add <code class="px-1 bg-gray-100 rounded">?ui=classic</code> to any console URL.
    </p>
  </div>
</template>
